import { useEffect, useState } from 'react';

export const useIsHydrated = () => {
    const [isHydrated, setIsHydrated] = useState(false);
    useEffect(() => setIsHydrated(true), []);
    return isHydrated;
};
